import get from 'lodash/get'

export const getUor = (state) => get(state, ['oidc', 'user', 'profile', 'claims', 'uor'], '')
export const getRoles = (state) => get(state, ['oidc', 'user', 'profile', 'role'], [])